import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../core/constants';
import useTranslation from '../../hooks/useTranslation';
import { LocalesUnion } from '../../types/interfaces';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  align-self: center;
  color: #2d271e;
  font-weight: 800;
  text-align: center;

  @media ${BREAKPOINTS.lg} {
    font-size: 26px;
  }
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: -60px;

  @media ${BREAKPOINTS.lg} {
    flex-direction: column;
    align-items: center;
    margin-bottom: -160px;
  }
`;

const StepTitle = styled.h3`
  color: #2d271e;
  font-weight: bold;
  font-size: 20px;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;

  @media ${BREAKPOINTS.lg} {
    max-width: 600px;
    margin-bottom: 140px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const StepImage = styled.img`
  width: 350px;
`;

const ImageHolder = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const StepDescription = styled.p`
  color: #909190;
  text-align: center;
`;

interface CProps {
  locale: LocalesUnion;
}

const HeroSteps: React.FC<CProps> = ({ locale }) => {
  const { t } = useTranslation(locale);

  return (
    <Container>
      <Title>{t('HOMEPAGE_HERO_STEPS_TITLE')}</Title>
      <StepsContainer className="mt-5">
        <StepContainer>
          <StepTitle>{t('HOMEPAGE_HERO_STEPS_DOWNLOAD_TITLE')}</StepTitle>
          <StepDescription>
            {t('HOMEPAGE_HERO_STEPS_DOWNLOAD_DESC')}
          </StepDescription>
          <ImageHolder>
            <StepImage className="mt-4" src="/images/step_download.svg" />
          </ImageHolder>
        </StepContainer>
        <StepContainer>
          <StepTitle>{t('HOMEPAGE_HERO_STEPS_INSPIRED_TITLE')}</StepTitle>
          <StepDescription>
            {t('HOMEPAGE_HERO_STEPS_INSPIRED_DESC')}
          </StepDescription>
          <ImageHolder>
            <StepImage className="mt-4" src="/images/step_inspiration.svg" />
          </ImageHolder>
        </StepContainer>
        <StepContainer>
          <StepTitle>{t('HOMEPAGE_HERO_STEPS_EXPLORE_TITLE')}</StepTitle>
          <StepDescription>
            {t('HOMEPAGE_HERO_STEPS_EXPLORE_DESC')}
          </StepDescription>
          <ImageHolder>
            <StepImage className="mt-4" src="/images/step_guide.svg" />
          </ImageHolder>
        </StepContainer>
      </StepsContainer>
    </Container>
  );
};

export default HeroSteps;
